import type { ModelLeadFilterData } from '@app/api/Leads/types';

import type { LeadsRegistryAssigneeOption } from '../types';

// Maps the `GetLeadsFilterData` visible users into assignee select options for
// the registry "assign responsible" mass action (mirrors the legacy
// `leadAssignees`, sourced from `VisibleUsers`).
export const mapLeadsFilterDataToAssigneeOptions = (
  filterData: ModelLeadFilterData | undefined
): LeadsRegistryAssigneeOption[] =>
  (filterData?.VisibleUsers ?? []).map(({ Id, Name }) => ({
    value: Id,
    label: Name ?? '',
  }));
